import { Component, computed } from '@angular/core';
import { get } from '../../../../../helpers/object-get';
import {
  BooleanColumnDefinition,
  EnumColumnDefinition,
  OptionalColumnDefinition,
} from '../../../types/column.type';
import { CellAdapter } from '../cell-adapter.component';

import { Badge } from '../../../../badge/badge.component';

@Component({
  selector: 'lepi-badge-cell',
  template: `
    @if (props()) {
      <lepi-badge [variant]="variant()!" [color]="props()?.color!">{{
        props()?.text
      }}</lepi-badge>
    } @else {
      <p>-</p>
    }
  `,
  imports: [Badge],
})
export class BadgeCell extends CellAdapter {
  gridOptions = this.store.tableOptions;
  variant = computed(() => this.gridOptions()?.badge?.variant);

  props = computed(() => {
    if (!this.column()) return;

    if (this.column().type === 'boolean') {
      return this.handleBooleanColumn();
    } else if (this.column().type === 'optional') {
      return this.handleOptionalColumn();
    } else {
      return this.handleEnumColumn();
    }
  });

  handleBooleanColumn() {
    const column = this.column() as BooleanColumnDefinition;
    const value = get(this.row(), this.column().field, '');
    return column.badgeProps![value === true ? 'true' : 'false']!;
  }

  handleEnumColumn() {
    const column = this.column() as EnumColumnDefinition;
    const value = get(this.row(), this.column().field, '');
    return column.badgeProps![value];
  }

  handleOptionalColumn() {
    const column = this.column() as OptionalColumnDefinition;
    const value = get(this.row(), this.column().field, '');
    return column.badgeProps![value ? 'some' : 'none'];
  }
}
